/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IMetadata, IMetadataComponent } from '../../store/types/MetadataTypes';
import { IAxisItem, ILevelsLayout } from '../../store/types/StateTypes';

function getColumns(levelsLayout: ILevelsLayout) {
    return levelsLayout.columns.map((column) => (
        {
            componentType: 'column',
            properties: {
                reference: (column as IAxisItem).id,
                detailFieldReference: (column as IAxisItem).field,
                aggregatedFieldReferences: [(column as IAxisItem).field],
                width: 125,
                horizontalAlign: 'Left',
                showSummary: false
            },
            components: []
        }
    ));
}

function getGroups(levelsLayout: ILevelsLayout) {
    return levelsLayout.rows.map((row) => (
        {
            componentType: 'group',
            properties: {
                reference: (row as IAxisItem).id,
                label: (row as IAxisItem).label
            },
            components: []
        }
    ));
}

function getTableUIComponent(metadataObj: IMetadata, levelsLayout: ILevelsLayout) {
    let res: IMetadataComponent | undefined;
    if (metadataObj.component) {
        res = metadataObj.component.components.find((comp) => (comp.componentType === 'table'));
    }

    if (!res) {
        res = {
            componentType: 'table',
            components: [...getColumns(levelsLayout), ...getGroups((levelsLayout))],
            properties: {
                fixedGrandTotal: false,
                fixedGroupTotal: false,
                fixedHeader: false,
                showDetails: true,
                showTotals: false,
                showDistinct: false
            }
        }
    }

    return res;
}

export { getTableUIComponent }
